import styled from "styled-components";

export const EditarDataCampanhaStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    border-radius: 30px;
    background-color: var(--base);
    padding: 25px 50px;
    width: 550px;
  }

  button {
    padding: 15px 30px;
    border: none;
    background-color: var(--amarelo);
    color: var(--principal);
    border-radius: 24px;
    font-size: 16px;
    font-weight: 700;
    width: max-content;
    margin: 10px auto 0px;
  }
  h4 {
    font-weight: 600;
  }

  .close {
    position: absolute;
    top: -20px;
    right: -15px;
    padding: 15px 15px;
    background-color: #fa5252;
    border-radius: 300px;
    font-size: 32px;
    font-weight: 400;
    color: var(--base);
  }

  .input{
    width: 100%;
    max-width: 100%;
  }

  input {
    margin-top: 23px;
    padding: 11px;
    border-radius: 10px;
    border: none;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    width: 100%;
  }

  .gerar {
    margin-left: 20px;
    background-color: var(--principal);
    color:  #ffffff;
  }

  .lds-dual-ring{
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: auto;
  }
`;
